import { useMutation } from '@tanstack/react-query';
import { sendContactEmail, ContactFormData } from '../api/contact';

export function useContactForm() {
    return useMutation({
        mutationFn: (data: ContactFormData) => sendContactEmail(data),
    });
}

